import { useState,useContext } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { getDomainValueForCode } from '../../../library/Core/SmartFunctions';

const CloseJobFormLayout = (props:any) => {
    console.log("props",props)
    const { state, dispatch } = useContext(SmartContext);
    const showFlag = state?.modalFlags?.showJobPostingCloseJob;
    const jobData = state?.modalData?.data;

    return (
    <div 
        className={`modal fade px-3 ${showFlag ? 'show' : ''}`} 
        id="closeJobPostingModal" 
        data-bs-backdrop="static" 
        data-bs-keyboard="false" tabIndex={-1}
        style={{ display: showFlag ? 'block' : 'none'}}>
        <div className="modal-dialog modal-dialog-centered max-800 mx-auto">
            <div className="modal-content">
                <div className="modal-header p-4 height-70 border-0 bg-gray-f2">
                    <h4 className="modal-title" id="staticBackdropLabel">Close Job Posting - <br/> {jobData?.title} @ {jobData?.companyId ? getDomainValueForCode(jobData?.companyId, 'COMPANY_CODE', state) : jobData?.otherCompany} </h4>
                    <button
                            type="button"
                            className="btn-close btn-close-small"
                            onClick={() => {
                                dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showJobPostingCloseJob' } });
                            }}
                            aria-label="Close"></button>
                    </div>
                <div className="modal-body p-4">
                {props.children}
                </div>
            </div>
        </div>
      </div>
    );
};  

export default CloseJobFormLayout;